import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CallbackComponent } from 'redux-oidc';
import { setAuthToken } from '../../../utils/api.utils';
import { UserManager } from '../../../utils';

class CallbackPage extends Component {
    successCallback = (user) => {
        if (user !== null) {
            setAuthToken(user.access_token);
        }
        this.props.history.push(this.getEntryPathName());
    }

    errorCallback = (error) => {
        console.log(error);
        this.props.history.push(this.getEntryPathName());
    }

    getEntryPathName = () => {
        var storageName = "EntryPathName";
        var storageValue = "/userlogin";
        if (typeof (Storage) !== "undefined") {
            if (sessionStorage.getItem(storageName) !== null) {
                storageValue = sessionStorage.getItem(storageName);
            }
        }
        return storageValue;
    }

    render() {
        return (
            <CallbackComponent userManager={UserManager} successCallback={this.successCallback} errorCallback={this.errorCallback}>
                <div>
                    Redirecting...
                </div>
            </CallbackComponent>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

function mapStateToProps(state) {
    const { history } = state;
        return {
            ...history
        };
} 

export default connect(mapStateToProps, mapDispatchToProps)(CallbackPage);

